module.exports = flarum.core.compat['utils/affixSidebar'];